// Angular
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { AuthService } from 'src/app/core/auth/_services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LayoutUtilsService } from 'src/app/core/_base/crud';
import { AuthNoticeService } from 'src/app/core/auth';

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

@Component({
  selector: 'kt-reset-password',
  templateUrl: './reset-mobile-password.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ResetMobilePasswordComponent implements OnInit {
  // Public properties

  hasFormErrors = false;
  resetPasswordForm: FormGroup;
  hide;
  hide3;
  loading;
  phone;
  token;
  companyId;

  /**
   * Component constructor
   *
   * @param fb: FormBuilder
   * @param auth: AuthService
   * @param store: Store<AppState>
   * @param layoutUtilsService: LayoutUtilsService
   */
  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private auth: AuthService,
    private snackBar: MatSnackBar,
    public authNoticeService: AuthNoticeService,
    private store: Store<AppState>,
    private layoutUtilsService: LayoutUtilsService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.phone = params[`phone`];
      this.token = params[`token`];
      this.companyId = params[`companyId`];
    });
    this.createForm();
  }

  createForm() {
    this.resetPasswordForm = this.fb.group(
      {
        password: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&#^])[A-Za-zd$@$!%*?&#^].{8,}',
            ),
            Validators.maxLength(100),
          ]),
        ),
        confirmPassword: new FormControl('', Validators.compose([Validators.required])),
      },
      {
        validator: ConfirmedValidator('password', 'confirmPassword'),
      },
    );
  }

  get f() {
    return this.resetPasswordForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.resetPasswordForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  /**
   * Reset
   */
  reset() {
    this.resetPasswordForm.markAsPristine();
    this.resetPasswordForm.markAsUntouched();
    this.resetPasswordForm.updateValueAndValidity();
    this.hasFormErrors = false;
  }

  submit() {
    this.hasFormErrors = false;
    const controls = this.resetPasswordForm.controls;
    /** check form */
    if (this.resetPasswordForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    const body = {
      phone: this.phone,
      password: controls.password.value,
      password2: controls.confirmPassword.value,
      token: this.token,
      companyId: parseInt(this.companyId, 10),
    };
    this.auth.resetMobilePassword(body).subscribe((res) => {
      if (res && res[`message`]) {
        this.authNoticeService.setNotice(
          this.translate.instant('AUTH.RESET.MOBILE_SUCCESS'),
          'success',
        );
      }
    });
    this.reset();
  }
}
